export enum ProjectStatus {
  Pending = 1,
  Exported = 2,
  Completed = 3,
}

export const PROJECT_STATUS_LABELS: any = {
  [ProjectStatus.Pending]: 'pending',
  [ProjectStatus.Exported]: 'exported',
  [ProjectStatus.Completed]: 'completed',
};
